import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CustomInputComponent } from 'components/input/custom-input/custom-input.component';
import { CustomSelectComponent } from 'components/input/custom-select/custom-select.component';
import { InputType } from 'enums/InputType';
import { ProductPlanModel } from 'models/generated/Entities.GormCrm.ProductPlan';
import { SelectListItemModel } from 'models/SelectList';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { FormValidationService } from 'services/form-validation.service';
import { NavigationService } from 'services/navigation.service';
import { ProductPlanService } from 'services/productplan.service';

@Component({
	selector: 'edit-product-plan-auto-renewal',
	templateUrl: './edit-product-plan-auto-renewal.component.html',
	providers: [FormValidationService],
	imports: [Layout, FormsModule, CustomSelectComponent, CustomInputComponent, TranslatePipe]
})
export class EditProductPlanAutoRenewalComponent {

	private _productPlan!: ProductPlanModel;
	inputType = InputType;
	nextPeriodSelect: SelectListItemModel[] = [];
	updatedProductPlanAnnualValueForRenewal?: number;
	updatedNextPeriod?: number;

	@Input()
	set productPlan(plan: ProductPlanModel) {
		this._productPlan = plan;
		this.updatedProductPlanAnnualValueForRenewal = plan.annualValueForRenewal;
		this.updatedNextPeriod = plan.nextPeriod;
		this.setNextPeriodSelect();
	}
	get productPlan() {
		return this._productPlan;
	}

	constructor(private readonly productPlanService: ProductPlanService, private readonly navigation: NavigationService) { }

	setNextPeriodSelect() {
		this.nextPeriodSelect = [
			new SelectListItemModel(12, '12'),
			new SelectListItemModel(24, '24')
		];
	}

	saveProductPlan() {
		return Promise.all([
			this.productPlanService.setProductPlanAnnualValueForRenewal(this.productPlan.id!, this.updatedProductPlanAnnualValueForRenewal!),
			this.productPlanService.setProductPlanNextPeriod(this.productPlan.id!, this.updatedNextPeriod!)
		])
			.then(() => { this.navigation.closeView(this); });

	}

}
